import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import moment from "moment";
import {SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";
import {store} from "@/plugins/vuex";

export default class InventorySearch extends BaseModel {
  department_uuid = null;
  category_uuid = null;
  receipt_uuid = [];
  dateRange = {startDate: null, endDate: null};
  title = null;
  company_name = null;
  item_no = null;
  status = [];
  sale_search = null;
  customer_uuid = null;
  asset_number = null;
  serial_number = null;
  account_manager_uuid = null;
  available_items_only = false;
  is_archived = false;
  is_draft = false;
  grouped_item_no = null;
  lot_no = null;
  collected_status = null;
  specialist_uuid = null;
  cataloguing_lifecycle = [];
  photography_lifecycle = [];
  reserve_type = null;
  receipts = []
  latest_auction_uuid = [];
  latest_auctions = [];
  latest_status = [];
  hammer_min = null;
  hammer_max = null;
  created_by_uuid = null;
  collector = null;
  item_location_uuid = null;
  proposal_status = null;
  proposal_suggestion = null;
  rules = {};
  images_value = null;
  transferred_from_branch_uuid = null;
  transferred_to_branch_uuid = null;
  rep_user_uuid = null;
  has_internal_images = false;
  has_attachments = false;

  attributeLabels = {
    department_uuid: i18n.t('Department'),
    category_uuid: i18n.t('Category'),
    customer_uuid: i18n.t('Customer'),
    receipt_uuid: i18n.t('Receipt'),
    title: i18n.t('Title'),
    item_no: i18n.t('Item Number'),
    status: i18n.t('Status'),
    sale_search: i18n.t('Sale'),
    asset_number: i18n.t('Asset Number'),
    serial_number: i18n.t('Serial Number'),
    available_items_only: i18n.t('Available Items Only'),
    is_archived: i18n.t('Show Archived Items'),
    is_draft: i18n.t('Show Draft Only'),
    hammer_min: i18n.t('Min Hammer'),
    hammer_max: i18n.t('Max Hammer'),
    company_name: i18n.t('Company Name'),
    specialist_uuid: i18n.t('Specialist'),
    grouped_item_no: i18n.t('Group Item No'),
    lot_no: i18n.t('Lot'),
    reserve_type: i18n.t('Reserve Type'),
    collector: i18n.t('Collector'),
    item_location_uuid: i18n.t('Item Location'),
    proposal_status: i18n.t('Proposal Status'),
    proposal_suggestion: i18n.t('Proposal Suggestion'),
    no_images: i18n.t('No Images'),
    has_images: i18n.t('Has Images'),
    transferred_from_branch_uuid: i18n.t('Transferred From Branch'),
    transferred_to_branch_uuid: i18n.t('Transferred To Branch'),
    has_internal_images: i18n.t('Has Internal Images'),
    has_attachments: i18n.t('Has Attachments'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    if (this.dateRange.startDate) {
      data.date_after = moment(this.dateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.date_before = moment(this.dateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }

    delete data.department;
    delete data.category;
    delete data.dateRange;
    delete data.customer;
    delete data.receipts;
    delete data.latest_auctions;
    delete data.specialist;
    delete data.created_by;
    delete data.rep_user;

    data.status = data.status.join(',')
    data.latest_status = data.latest_status.join(',')
    data.receipt_uuid = data.receipt_uuid.join(',')
    data.latest_auction_uuid = data.latest_auction_uuid.join(',')
    data.cataloguing_lifecycle = data.cataloguing_lifecycle ? data.cataloguing_lifecycle.join(',') : null;
    data.photography_lifecycle = data.photography_lifecycle ? data.photography_lifecycle.join(',') : null;

    data.available_items_only ? data.available_items_only = 'true' : delete data.available_items_only
    data.is_archived ? data.is_archived = 'true' : data.is_archived = 'false'
    data.has_internal_images ? data.has_internal_images = 'true' : data.has_internal_images = 'false'
    data.has_attachments ? data.has_attachments = 'true' : data.has_attachments = 'false'

    if (data.is_draft) {
      data.is_draft = 'true'
    } else {
      delete data.is_draft
    }

    if (store.state && store.state.global && store.state.global.dynamicFieldsFilters) {
      let inventoryDynamicFieldsFilters = store.state.global.dynamicFieldsFilters.inventories;
      if (inventoryDynamicFieldsFilters && inventoryDynamicFieldsFilters.length > 0) {
        for (let field of inventoryDynamicFieldsFilters) {
          if (field.type === 'checkbox') {
            data[field.key] ? data[field.key] = 'true' : delete data[field.key]
          }
        }
      }
    }

    if (data.item_location_uuid) {
      data.item_location_uuid_deep = data.item_location_uuid
      delete data.item_location_uuid
    }

    if (data.images_value === 'has_images') {
      data.has_images = 'true'
    } else if (data.images_value === 'without_images') {
      data.no_images = 'true'
    }
    delete data.images_value

    return data;
  }

}

defineTranslatableProperties(InventorySearch);
